export default __webpack_public_path__ + "static/media/MarcaMobileFooter.e74a6638.jpg";